import { MdFormatListBulletedAdd } from "react-icons/md";
import { BsCheck2Circle } from "react-icons/bs";
import { ImCancelCircle } from "react-icons/im";
import { BsFillSendCheckFill } from "react-icons/bs";

const lbanTenant = {
  clientId: "f9df6cfc-2b4c-4654-88e1-c9acea243247",
  authority: `https://login.microsoftonline.com/39dab133-5d7b-4bec-8eca-7f89b173e27f`,
};

const oblTenant = {
  clientId: "9fd74419-b276-444e-9695-be9fc1747fac",
  authority: `https://login.microsoftonline.com/55fbc70a-e57f-4db4-9a04-388a9338ca95`,
};

// export const msalConfig = {
//   auth: {
//     clientId: oblTenant.clientId,
//     authority: oblTenant.authority,
//   },
//   cache: {
//     cacheLocation: "localStorage",
//     storeAuthStateInCookie: false,
//   },
// };
export const getMsalConfig = (environment: any) => {
  if (environment === "NMFB") {
    return {
      auth: {
        clientId: oblTenant.clientId,
        authority: oblTenant.authority,
      },
      cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
      },
    };
  } else {
    return {
      auth: {
        clientId: lbanTenant.clientId,
        authority: lbanTenant.authority,
      },
      cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
      },
    };
  }
};
export function formatNumber(num: number) {
  if (Math.abs(num) >= 1_000_000_000) {
    return (num / 1_000_000_000).toFixed(1) + "B";
  } else if (Math.abs(num) >= 1_000_000) {
    return (num / 1_000_000).toFixed(1) + "M";
  } else if (Math.abs(num) >= 1_000) {
    return (num / 1_000).toFixed(1) + "k";
  } else {
    return num.toString();
  }
}

export function getIconForStatus(status: any) {
  const icons = {
    Pending: MdFormatListBulletedAdd,
    Approved: BsCheck2Circle,
    Declined: ImCancelCircle,
    Disbursed: BsFillSendCheckFill,
  } as any;
  return icons[status];
}

export const stepStatus = Object.freeze({
  pending: "pending",
  exact: "exact",
  completed: "completed",
});
export const loanSteps = [
  {
    order: 1,
    title: "Customer Information",
    status: stepStatus.exact,
  },
  {
    order: 2,
    title: "Loan Details",
    status: stepStatus.pending,
  },
  {
    order: 3,
    title: "Financial Analysis",
    status: stepStatus.pending,
  },
  {
    order: 4,
    title: "Financial Ratio",
    status: stepStatus.pending,
  },
  {
    order: 5,
    title: "Checklist Items",
    status: stepStatus.pending,
  },
  {
    order: 6,
    title: "Approval",
    status: stepStatus.pending,
  },
];
